import { Box, Flex, useMantineTheme } from "@mantine/core";
import { useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import ManageRequests from "src/components/ManageRequests";

export const ManageRequestsRoute = () => {
    const navigate = useNavigate();
    const _theme = useMantineTheme();

    useEffect(() => {
        if (window.location.hash === "#/manageRequests") navigate({ to: "/manageRequests" });
    }, [navigate]);

    return (
        <Flex p="xl" direction="column" gap="md">
            <Box>
                <ManageRequests />
            </Box>
        </Flex>
    );
};
